define(
  'MHI.UOMFeatExt.Main', [
    'Utils',
    'jQuery',
    'ProductList.Item.Edit.View',
    'ProductList.DisplayFull.View',
    'underscore'
  ], function(
    Utils,
    jQuery,
    ProductListItemEditView,
    ProductListDisplayFullView,
    _
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {
        var pdp = container.getComponent('PDP');
        var cart = container.getComponent('Cart');
        var environment = container.getComponent('Environment');
        var excludeItemFieldId = 'custitem_mhi_requires_uom_cust';

        if (pdp) {
          pdp.addToViewContextDefinition('ProductDetails.Quantity.View', 'requiresUOM', 'boolean', function(context) {

            var requiresUOM = context.model.item.custitem_mhi_requires_uom_cust;

            if (requiresUOM) {
              var uomOptions = ['custcol_number_pieces_option', 'custcol_custom_length_option'];
              var length = 1;
              var diameter = 1;
              var item = pdp.getItemInfo();

              if (item) {
                if (
                  item[uomOptions[0]] &&
                  !isNaN(item[uomOptions[0]]) &&
                  parseInt(item[uomOptions[0]], 10).toString() === String(parseInt(item[uomOptions[0]], 10))
                ) {
                  length = parseInt(item[uomOptions[0]], 10);
                }
                if (
                  item[uomOptions[1]] &&
                  !isNaN(item[uomOptions[1]]) &&
                  parseInt(item[uomOptions[1]], 10).toString() === String(parseInt(item[uomOptions[1]], 10))
                ) {
                  diameter = parseInt(item[uomOptions[1]], 10);
                }
              }

              if (!length) {
                length = parseInt(Utils.getParameterByName(window.location.href, uomOptions[0]), 10) ||
                  (pdp.application.getLayout().getCurrentView().$('[name="' + uomOptions[0] + '"]').val() || 1);
              }

              if (!diameter) {
                diameter = parseInt(Utils.getParameterByName(window.location.href, uomOptions[1]), 10) ||
                  (pdp.application.getLayout().getCurrentView().$('[name="' + uomOptions[1] + '"]').val() || 1);

              }

              var customQty = length * diameter;

              if (customQty) {
                pdp.setQuantity(customQty);
              }
            }

            return requiresUOM;
          });

          pdp.on('afterOptionSelection', function(option) {
            // reserved block if still needed to implement the field reset when child item is selected
          });

        }

        if (cart) {

          cart.addToViewContextDefinition('Cart.Item.Summary.View', 'requiresUOM', 'boolean', function(context) {
            return context.line.item.custitem_mhi_requires_uom_cust;
          });

          cart.cancelableOn('beforeAddLine', function(cartObj) {

            var view = container.getLayout().getCurrentView();

            if (view.el.className == 'ProductListDetailsView') {
              return false;
            }

            var item = view.model.get('item');
            var selected_item = !_.isUndefined(view.model.getSelectedMatrixChilds()[0])
              ? view.model.getSelectedMatrixChilds()[0]
              : item;

            if (selected_item.get('custitem_mhi_requires_uom_cust')) {
              var pcsOption = _.findWhere(cartObj.line.options, { cartOptionId: 'custcol_number_pieces_option' });
              var lengthOption = _.findWhere(cartObj.line.options, { cartOptionId: 'custcol_custom_length_option' });

              if (!pcsOption.value || !lengthOption.value) {
                return jQuery.Deferred()
                             .reject('Please enter values for Custom Length in Inches and Number of Custom Length Pieces fields.');
              }
            }
          });
        }

        if (environment) {
          environment.defineSearchMasterOptions(
            'itemsSearcher',
            function(searchApiMasterOptions) {

              searchApiMasterOptions[excludeItemFieldId] = false;

              return searchApiMasterOptions;
            });

          environment.defineSearchMasterOptions(
            'Facets',
            function(searchApiMasterOptions) {

              searchApiMasterOptions['facet.exclude'] = excludeItemFieldId;

              return searchApiMasterOptions;
            });

        }

        _.extend(ProductListDisplayFullView.prototype, {
          getContext: _.wrap(ProductListDisplayFullView.prototype.getContext, function(fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));
            var line = this.model;
            var requiresUOM = line.get('item').get('custitem_mhi_requires_uom_cust');

            context.requiresUOM = requiresUOM;
            return context;
          })
        });
        _.extend(ProductListItemEditView.prototype, {
          getContext: _.wrap(ProductListItemEditView.prototype.getContext, function(fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));
            var line = this.model;
            var requiresUOM = line.get('item').get('custitem_mhi_requires_uom_cust');

            context.requiresUOM = requiresUOM;
            return context;
          })
        });

      }
    };
  });
